export enum PaymentStatus {
    ACCEPTED = 'ACCEPTED',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED',
    FAILURE = 'FAILURE',
    OPEN = 'OPEN',
    SUCCESS = 'SUCCESS'
}
